import { userConstants } from "../_constants";
import { userService } from "../_services";
import { errorActions } from "./";
import { history } from "../_helpers";

export const userActions = {
  login,
  logout,
  getUserInfo,
  mainLogin,
  getGeoLocation,
};

function mainLogin(username, password) {
  return (dispatch) => {
    userService.mainLogin(username, password).then(
      (res) => {
        if (res.error) {
          dispatch(failure(res.message));
          dispatch(errorActions.setError(res.message));
        } else {
          dispatch(success());
        }
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(errorActions.setError(error.message));
      }
    );
  };

  function success() {
    return { type: userConstants.MAIN_LOGIN_SUCCESS };
  }

  function failure(error) {
    return { type: userConstants.MAIN_LOGIN_FAILURE, error };
  }
}

// User login action
function login(username, password) {
  return (dispatch) => {
    dispatch(request({ username }));

    userService.login(username, password).then(
      (res) => {
        if (res.error) {
          // dispatch(failure(res.message));
          dispatch(errorActions.setError(res.message));
        } else {
          dispatch(success(res.data));
          history.push("/dashboard");
        }
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(errorActions.setError(error.message));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

// User logout action
function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function getUserInfo() {
  return (dispatch) => {
    userService
      .getUserInfo()
      .then(({ data }) => {
        dispatch(success(data.data));
        dispatch(getGeoLocation());
      })
      .catch((error) => console.log(error));
  };

  function success(data) {

    return { type: userConstants.GET_USER_INFO, payload: data };
  }
}

function getGeoLocation() {
  return (dispatch) => {
    userService
      .getGeoLocation()
      .then(({ data }) => {
        dispatch({ type: userConstants.GET_GEO_LOCATION, payload: data });
      })
      .catch((error) => {
        console.log(error);
      });
  };
}
